import Styled from 'styled-components';
import ReactQuill from 'react-quill';

const EditorWrapper = Styled(ReactQuill)`
    .ql-editor.ql-blank::before{
        direction: rtl;
        text-align: right;
        color: gray;
        font-style: unset;
    }
`;

export { EditorWrapper }
